<template>
 <div class="row calculate-price-block">
    <div class="col">
        <CalculatePriceBlockFormat v-if="isFormat" :data="block.formats" @updateSelection="updateFormats"/>
        <CalculatePriceBlockOperation v-if="isOperation" :data="block.operation" @selectOperation="updateOperation"/>
        <CalculatePriceBlockOperationCounter class="mt-3" v-if="isOperationCounter" :data="block.operation_counter" @selectOperationCounter="selectOperationCounter"/>
        <CalculatePriceBlockOrientation v-if="isOrientation" :data="block.orientation" @selectOrientation="selectOrientation"/>
        <CalculatePriceBlockProcessingSides v-if="isProcessingSides"  :data="block.processing_sides" @selectProcessingSides="selectProcessingSides"/>
        <CalculatePriceBlockFree v-if="isFreeBlock" :blockName="block.name" @updateFreeItems="updateFreeItems"/>
    </div>
  </div>
</template>
<script>
import CalculatePriceBlockFormat from './CalculatePriceBlockFormat'
import CalculatePriceBlockOperation from './CalculatePriceBlockOperation'
import CalculatePriceBlockOperationCounter from './CalculatePriceBlockOperationCounter'
import CalculatePriceBlockOrientation from './CalculatePriceBlockOrientation'
import CalculatePriceBlockProcessingSides from './CalculatePriceBlockProcessingSides'
import CalculatePriceBlockFree from './CalculatePriceBlockFree'

export default {
  name: 'CalculatePriceBlock',
  components: { CalculatePriceBlockFormat, CalculatePriceBlockOperation, CalculatePriceBlockOperationCounter, CalculatePriceBlockOrientation, CalculatePriceBlockProcessingSides, CalculatePriceBlockFree },
  props: {
    block: {
      default: null
    }
  },
  data: () => {
    return {
    }
  },
  methods: {
    updateFormats (data) {
      this.block.selectedFormat = data
    },
    updateOperation (data) {
      this.block.operation = { ...this.block.operation, isSelected: data.isSelected }
    },
    selectOperationCounter (data) {
      this.block.selectedOperationCounter = data
    },
    selectOrientation (data) {
      this.block.selectedOrientation = data
    },
    selectProcessingSides (data) {
      this.block.selectedProcessingSides = data
    },
    updateFreeItems (data) {
      this.block.freeblock = data
    }
  },
  computed: {
    isFormat () {
      return !!this.block.formats
    },
    isOperation () {
      return !!this.block.operation
    },
    isOperationCounter () {
      return !!this.block.operation_counter && this.isOperation && this.block.operation.isSelected
    },
    isOrientation () {
      return !!this.block.orientation
    },
    isProcessingSides () {
      return !!this.block.processing_sides
    },
    isFreeBlock () {
      return this.block.algorithm.id === 27
    }
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
</style>
